// Tax is the computed return. Rate and jurisdiction configuration lives in
// Settings → Tax; contractor totals are a Reports card, and planning estimates
// are a separate Tax subpage. Nothing here files or stores a return.
import { Button } from "@sylviq/ui-react-web/components/ui/button";
import { PageHeader } from "@sylviq/ui-react-web/components/ui/page-header";
import { Link } from "@tanstack/react-router";
import { ReturnTab } from "./ReturnTab";

export function TaxPage() {
  return (
    <div className="grid gap-6">
      <PageHeader
        title="Tax"
        description="A computed output/input tax calculation for any period — a worksheet for a file-yourself return. Nothing is filed or stored."
        actions={
          <Button asChild variant="secondary">
            <Link to="/tax/estimates">Tax estimates</Link>
          </Button>
        }
      />
      <ReturnTab />
    </div>
  );
}
